import { render, staticRenderFns } from "./UnnamedApts.vue?vue&type=template&id=98ec0a80"
import script from "./UnnamedApts.vue?vue&type=script&lang=js"
export * from "./UnnamedApts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports